import React from 'react';

export default function DashboardEnvironmental(props) {
    return (
        <div className="card border-0 rounded-15px bg-white shadow h-100 px-3">
            <div className="card-body card-widget">
                <div className={'row'}>
                    <div className={'col'}>
                        <h4 className="text-dark-blue">{$t('Environmental')}</h4>
                    </div>
                </div>

                <div className={'row'}>
                    <div className={'col'}>
                        <div className={'row my-3'}>
                            <div className={'col-12'}>
                                <div className={'row'}>
                                    <div className={'col'}>
                                        <h4 className={'text-blue mb-2'}>{$t('Carbon Footprint')}</h4>
                                    </div>
                                </div>
                                <div className={'row'}>
                                    <div className={'col-12'}>
                                        <div className={'row h-100'}>
                                            <div className={'col-12 col-lg-6'}>
                                                <div className="card border-0 rounded-15px bg-white shadow h-100">
                                                    <div className="card-body card-widget">
                                                        <div className={'d-flex flex-column justify-content-center h-100 p-3'}>
                                                            <h4 className={'text-blue mb-2'}>{$t('Carbon Emissions (Tonnes CO2)')}</h4>
                                                            <h3 className={'text-blue'}>{props.format(props.data.carbon_emissions)}</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={'col-12 col-lg-6'}>
                                                <div className="card border-0 rounded-15px bg-white shadow h-100">
                                                    <div className="card-body card-widget">
                                                        <div className={'d-flex flex-column justify-content-center h-100 p-3'}>
                                                            <h4 className={'text-blue mb-2'}>{$t('Carbon Offset (Tonnes CO2)')}</h4>
                                                            <h3 className={'text-blue'}>{props.format(props.data.carbon_offset)}</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={'col-12'}>
                                <div className={'row'}>
                                    <div className={'col'}>
                                        <h4 className={'text-blue my-2'}>{$t('Waste')}</h4>
                                    </div>
                                </div>
                                <div className={'row'}>
                                    <div className={'col-12'}>
                                        <div className={'row h-100'}>
                                            <div className={'col-12 col-lg-6'}>
                                                <div className="card border-0 rounded-15px bg-white shadow h-100">
                                                    <div className="card-body card-widget">
                                                        <div className={'d-flex flex-column justify-content-center h-100 p-3'}>
                                                            <h4 className={'text-blue mb-2'}>{$t('Waste Produced (Tonnes)')}</h4>
                                                            <h3 className={'text-blue'}>{props.format(props.data.waste_produced)}</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={'col-12 col-lg-6'}>
                                                <div className="card border-0 rounded-15px bg-white shadow h-100">
                                                    <div className="card-body card-widget">
                                                        <div className={'d-flex flex-column justify-content-center h-100 p-3'}>
                                                            <h4 className={'text-blue mb-2'}>{$t('% sent to landfill')}</h4>
                                                            <h3 className={'text-blue'}>{props.format(props.data.waste_sent_to_landfill_percent)} %</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
